import * as React from "react";

export function MoneyCircle(props) {
  return (
    <svg
      width={92}
      height={92}
      viewBox="0 0 92 92"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_d_23_715)">
        <rect
          x={18.9229}
          y={16}
          width={54.7287}
          height={54.7287}
          rx={27.3644}
          fill="#FAFAFA"
        />
      </g>
      <path
        d="M56.582 33.28a13.63 13.63 0 00-10.484-4.904c-7.544 0-13.658 6.115-13.658 13.658 0 .933.093 1.844.271 2.724m26.682-5.867c.237 1.01.363 2.062.363 3.143 0 7.544-6.115 13.659-13.658 13.659-4.346 0-8.217-2.03-10.719-5.192"
        stroke="#081533"
        strokeWidth={1.82112}
        strokeLinecap="round"
      />
      <path
        d="M57.252 30.197v3.642h-3.643M38.586 50.23h-3.643v3.642"
        stroke="#081533"
        strokeWidth={1.82112}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46.098 34.75v14.569"
        stroke="#081533"
        strokeWidth={1.82112}
        strokeLinecap="round"
      />
      <path
        d="M49.394 38.668c-.218-.965-1.464-2.04-3.285-2.04-1.822 0-3.223 1.184-3.223 2.679 0 3.394 6.757 1.65 6.757 5.59 0 1.423-1.713 2.63-3.534 2.63-1.822 0-3.083-1.12-3.457-2.32"
        stroke="#081533"
        strokeWidth={1.82112}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <filter
          id="filter0_d_23_715"
          x={0.898851}
          y={0.894866}
          width={90.7765}
          height={90.7765}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={2.91887} />
          <feGaussianBlur stdDeviation={9.012} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_23_715"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_23_715"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}
